import { render, staticRenderFns } from "./msgDialog.vue?vue&type=template&id=c67c08ac&"
import script from "./msgDialog.vue?vue&type=script&lang=js&"
export * from "./msgDialog.vue?vue&type=script&lang=js&"
import style0 from "./msgDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports